export const state = () => ({
  message: [],
  isLoading: false,
  suports: [],
  suportsResolveds: [],
  modalVisibility: {
    delete: false,
    changeSubject: false,
    reply: false,
    distribute: false,
    makePublic: false,
    add: false,
    setResolved: false,
  },
  filterSuports: [],
  filterSuportsResolveds: [],
})

export const mutations = {
  toggleModal(state, modal) {
    state.modalVisibility[modal] = !state.modalVisibility[modal]
  },
  toggleLoading(state) {
    state.isLoading = !state.isLoading
  },
  setMessage(state, message) {
    state.message = message
  },
  setSuports(state, suport) {
    state.suports = suport
  },
  setSuportsResolveds(state, suportResolveds) {
    state.suportsResolveds = suportResolveds
  },
  setFiltersSuports(state, suports) {
    state.filterSuports = suports
  },
  setFiltersSuportsResolveds(state, suports) {
    state.filterSuportsResolveds = suports
  },
}

export const actions = {
  getSuports(store, force) {
    const classId = localStorage.classId
    if(!classId) return
    if (store.state.suports.length === 0 || force) {
      store.commit('toggleLoading')
      this.$axios
        .$get(`/api/v1/academic/support/class/${classId}`)
        .then((res) => {
          store.commit('setSuports', res)
          store.commit('setFiltersSuports', res)
          store.commit('toggleLoading')
        })
    }
  },
  getSuportsResolveds(store, force) {
    const classId = localStorage.getItem('classId')
    if(!classId) return
    if (store.state.suportsResolveds.length === 0 || force) {
      store.commit('toggleLoading')
      this.$axios
        .get(`/api/v1/academic/support/class/${classId}/resolved`)
        .then((res) => {
          store.commit('setSuportsResolveds', res.data)
          store.commit('setFiltersSuportsResolveds', res.data)
          store.commit('toggleLoading')
        })
    }
  },
  filterSuportsByType(store, subject) {
    const suportsFilter = store.state.suports.filter((suport) => {
      return suport.type
        .toLowerCase()
        .trim()
        .includes(subject.toLowerCase().trim())
    })
    const suportsResolvedsFilter = store.state.suportsResolveds.filter(
      (suport) => {
        return suport.type
          .toLowerCase()
          .trim()
          .includes(subject.toLowerCase().trim())
      }
    )
    store.commit('setFiltersSuports', suportsFilter)
    store.commit('setFiltersSuportsResolveds', suportsResolvedsFilter)
  },
}
